exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FinishedQuiz__FinishedQuiz--2KeHu{\r\n    padding: 20px;\r\n    color:#fff;\r\n    border:2px solid #fff;  \r\n    border-radius: 5px;\r\n    box-sizing: border-box;    \r\n    margin: 0 10px;\r\n}\r\n\r\n.FinishedQuiz__FinishedQuiz--2KeHu ul{\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.FinishedQuiz__FinishedQuiz--2KeHu ul li i{\r\n    margin-left:10px;\r\n}\r\n\r\n.FinishedQuiz__error--3HVNl{\r\n    color: rgba(255, 0, 0, 0.7)\r\n}\r\n\r\n.FinishedQuiz__success--2INri{\r\n    color: rgba(0, 255, 0, 0.7)\r\n}", ""]);

// exports
exports.locals = {
	"FinishedQuiz": "FinishedQuiz__FinishedQuiz--2KeHu",
	"error": "FinishedQuiz__error--3HVNl",
	"success": "FinishedQuiz__success--2INri"
};